export default __webpack_public_path__ + "static/why--stack-8cda598bf2e46895dadf1e088d934165.svg";